module.exports = __webpack_public_path__ + "img/card1-image.3fc31fb2.svg";